export const PAYCOR_SIGNIN_URL = 'https://hcm.paycor.com/authentication/signin';

export const REIMBURSEMENT_GUIDELINES = {
  name: 'Expense Reimbursement Guidelines',
  file: 'expense-reimbursement-guidelines.pdf',
  description: 'Guidelines and instructions for expense reimbursement'
};

export const REIMBURSEMENT_DOCUSIGN_URL =
  'https://na4.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=0119b814-411d-4426-a1d1-078e2be98afb&env=na4&acct=65d220c3-8542-40b4-82f8-f18dd912cb03&v=2';

export const CELLPHONE_STIPEND_DOCUSIGN_URL =
  'https://na4.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=dfca1bd5-e534-4b62-aa4f-2ad8a601a7f8&env=na4&acct=65d220c3-8542-40b4-82f8-f18dd912cb03&v=2';

export const CELLPHONE_STIPEND_POLICY = {
  name: 'Cellphone Stipend Policy',
  file: 'cellphone-reimbursement-policy.pdf',
  description: 'Policy for the cellphone stipend'
};

/** Forms shown on the Vendor Forms page only. */
export const VENDOR_FORMS = [
  {
    name: 'Vendor ACH Form',
    file: 'vendor-ach-form.pdf',
    icon: 'fas fa-university',
    description: 'Vendor ACH setup form'
  },
  {
    name: 'Check Request Form',
    file: 'check-request-form.pdf',
    icon: 'fas fa-money-check-alt',
    description: 'Form for requesting checks'
  },
  {
    name: 'CFSF W-9 Form',
    file: 'cfsf-w9.pdf',
    icon: 'fas fa-file-alt',
    description: 'W-9 tax form'
  }
];

/** Additional finance PDFs linked from the Finance nav sections. */
export const FINANCE_NAV_FORMS = [
  {
    name: 'Missing Receipt Affidavit',
    file: 'missing-receipt-affidavit.pdf',
    icon: 'fas fa-file-signature'
  },
  {
    name: 'Cellphone Stipend Policy',
    file: 'cellphone-reimbursement-policy.pdf',
    icon: 'fas fa-file-contract'
  }
];

export const VENDOR_FORMS_PDF_BASE = '/vendor-forms';

export const financeFormPdfUrl = (file) => `${VENDOR_FORMS_PDF_BASE}/${file}`;
